// extracted by mini-css-extract-plugin
export default {"signerDetail":"styles-module__signerDetail___y6tkJ"};